/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */

import * as React from 'react'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'
import DynamicFormIcon from '@mui/icons-material/DynamicForm'
import ImageIcon from '@mui/icons-material/Image'

import {ToggleFunctionType} from "../layouts/Layout"
import GridSelectDrawer from "./GridSelectDrawer"


interface AddNodeActionProps {
  open: boolean
  toggleDrawer: ToggleFunctionType
}


const AddNodeDrawer: React.FC<AddNodeActionProps> = ({open, toggleDrawer}) => {
  const items = [
    {text: 'Document', icon: <TextSnippetIcon/>},
    {text: 'Image', icon: <ImageIcon/>},
    {text: 'Form', icon: <DynamicFormIcon/>},
    {text: 'Something Larger', icon: <TextSnippetIcon/>},
    {text: 'Image', icon: <ImageIcon/>},
    {text: 'Form', icon: <DynamicFormIcon/>},
  ]

  const addNewNode = (selectedItem: string, textInput: string) => {
    if (textInput) return true
  }

  return (
    <GridSelectDrawer
      title="Add an Item to the Graph (Tree)"
      subtitle="Select from the following content types:"
      anchor="bottom"
      open={open}
      toggleDrawer={toggleDrawer}
      items={items}
      onSelect={addNewNode}
      inputLabel="New Node Name"
      inputProps={{"aria-label": "enter new item name"}}
      inputId="add-note-drawer-1"
      focusTextOnSelection={true}
    />
  )
}

export default AddNodeDrawer
